import { createAction } from 'Helpers';
import authenticationTypes from './types';

const authenticationActions = {
	checkOtpRequest: createAction(authenticationTypes.CHECK_OTP.REQUEST),

	loginByEmailRequest: createAction(authenticationTypes.LOGIN_BY_EMAIL.REQUEST),

	sessionCheckRequest: createAction(authenticationTypes.SESSION_CHECK.REQUEST),

	loginSuccess: createAction(authenticationTypes.LOGIN.SUCCESS),
	loginFailure: createAction(authenticationTypes.LOGIN.FAILURE),

	loginByOtpRequest: createAction(authenticationTypes.LOGIN_BY_OTP.REQUEST),
	loginByOtpSuccess: createAction(authenticationTypes.LOGIN_BY_OTP.SUCCESS),
	loginByOtpFailure: createAction(authenticationTypes.LOGIN_BY_OTP.FAILURE),

	loginByIdRequest: createAction(authenticationTypes.LOGIN_BY_ID.REQUEST),
	loginByIdSuccess: createAction(authenticationTypes.LOGIN_BY_ID.SUCCESS),
	loginByIdFailure: createAction(authenticationTypes.LOGIN_BY_ID.FAILURE),

	getSessionsRequest: createAction(authenticationTypes.GET_SESSIONS.REQUEST),
	getSessionsSuccess: createAction(authenticationTypes.GET_SESSIONS.SUCCESS),
	getSessionsFailure: createAction(authenticationTypes.GET_SESSIONS.FAILURE),

	logoutRequest: createAction(authenticationTypes.LOGOUT.REQUEST),
	logoutSuccess: createAction(authenticationTypes.LOGOUT.SUCCESS),

	appInitRequest: createAction(authenticationTypes.APP_INIT.REQUEST),
	appInitSuccess: createAction(authenticationTypes.APP_INIT.SUCCESS),
};

export default authenticationActions;
